module.exports = __webpack_public_path__ + "img/2.ef1762a0.png";